import React, {useEffect, useMemo} from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid';
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { UPDATE_AMOUNT_ON_HAND } from '../../Reconcile/ReconcileReducer';
import { getBatchInfoByReceiptItemType } from '../../Reconcile/ReconcileActions';


const EnterTotals = ({selectedUserID}) => {
  const dispatch = useDispatch();
  const { batches = [], selectedBatches, batchInfo } = useSelector((state) => state.reconcile, shallowEqual);
  const enterTotalsColumns = [
    { "field": "Desc", 
      "flex": 0.75, 
      "minWidth": 90, 
      "headerName": "Receipt Item Type", 
      "disableColumnMenu": true,
    },
    { "field": "AmountOnHand", 
      "flex": 0.75, 
      "minWidth": 90, 
      "headerName": "Amount on Hand", 
      "disableColumnMenu": true,
      renderCell: (params) => {
        return (
          <React.Fragment>
            <TextInput 
              aria-label={"Amount On Hand"} 
              placeholder="0.00"
              onChange={(e) => {updateAmountOnHand(e.target.value, params.row);}} />
            {params.row.Amount ? <span style={{marginLeft: '20px'}}> ( ${params.row.Amount} )</span> : null}
          </React.Fragment>
        )
      },
    }
  ];

  useEffect(() => {
    batches.filter((batch) => {
      return selectedBatches.includes(batch.id)
    }).forEach((batch) => {
      dispatch(getBatchInfoByReceiptItemType(selectedUserID, batch.id));
    })
  }, [batches, selectedBatches]);

  const updateAmountOnHand = (value, row) => {
    dispatch({type: UPDATE_AMOUNT_ON_HAND, value, row})
  }

  const reconcileBatches = useMemo(() => {
    let items = [];
    selectedBatches.forEach((id) => {
      if (batchInfo[id]) {
        batchInfo[id].forEach((info) => {
          items.push({...info, batchTypeID: id});
        })
      }
    })
    return items;
  }, [batchInfo, selectedBatches])

  return (
    <div className='accounting-table'>
      <GraniteDataGrid
        columns={enterTotalsColumns}
        rows={reconcileBatches}
        pagination={undefined}
        rowsPerPageOptions={[25, 50, 100]}
      />
    </div>
  )
}

export default EnterTotals 